import { IEntity } from '../../../primitives';
import { sharedTableConfigResolver } from './shared-table-config';
import { ITableConfig } from './table-config';
import { ITableFieldConfig } from './table-field-config';
import { TemplateRef } from '@angular/core';
import { ActionsManager } from '../table-actions/models';

export class TableManager<TEntity extends IEntity<string>> implements ITableConfig {
  fields: ITableFieldConfig[];
  template: TemplateRef<any>;

  private constructor(config: ITableConfig) {
    this.fields = config.fields;
    this.template = config.template;
  }

  static create<TEntity extends IEntity<string>>(config: ITableConfig): TableManager<TEntity> {
    return new TableManager<TEntity>(config);
  }

  getTableConfigResolver(actionManager: ActionsManager<TEntity>): sharedTableConfigResolver<TEntity> {
    return (items) => ({
      headers: actionManager.canUseAny() ? [...this.getHeaders(), 'GENERAL.ACTIONS'] : this.getHeaders(),
      data: items,
      dataKeys: actionManager.canUseAny() ? [...this.getDataKeys(), 'Actions'] : this.getDataKeys()
    });
  }

  private getHeaders(): string[] {
    return this.fields.map((x) => x.displayName);
  }

  private getDataKeys(): string[] {
    return this.fields.map((x) => x.name);
  }
}
